import React from 'react';

const BrandMark = ({ className = "w-8 h-8", variant = "default" }) => {
  // A professional logo combining a maple leaf silhouette with network nodes/connections
  return (
    <div className={`relative ${className} flex items-center justify-center`}>
      <svg 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        {/* Stylized Maple Leaf / Neural Node Hybrid */}
        <path 
          d="M12 2L14.5 7H19.5L15.5 10.5L17 15.5L12 12.5L7 15.5L8.5 10.5L4.5 7H9.5L12 2Z" 
          fill={variant === 'white' ? '#FFFFFF' : '#EA580C'} 
          className="drop-shadow-sm"
        />
        {/* Vein / Connection lines */}
        <circle cx="12" cy="7.5" r="1.2" fill={variant === 'white' ? '#EA580C' : '#FFFFFF'} />
        <circle cx="9.5" cy="11.5" r="1" fill={variant === 'white' ? '#EA580C' : '#FFFFFF'} />
        <circle cx="14.5" cy="11.5" r="1" fill={variant === 'white' ? '#EA580C' : '#FFFFFF'} />
        <path d="M12 7.5L9.5 11.5M12 7.5L14.5 11.5M12 7.5V11" stroke={variant === 'white' ? '#EA580C' : '#FFFFFF'} strokeWidth="0.5" />
      </svg>
    </div>
  );
};

export default BrandMark;